import { LinkOutlined } from "@ant-design/icons";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import { SettingDrawer } from "@ant-design/pro-components";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history, Link } from "@umijs/max";
import { AvatarDropdown, AvatarName, Footer, SelectLang } from "@/components";
import { currentUser as queryCurrentUser } from "@/services/ant-design-pro/api";
import defaultSettings from "../config/defaultSettings";
import { errorConfig } from "./requestErrorConfig";
import "@ant-design/v5-patch-for-react-19";
import { userControllerGetUserInfo } from "./services/ant-design-pro/user";
import { commonControllerGetCenterList } from "./services/ant-design-pro/common";

const isDev = process.env.NODE_ENV === "development";
const loginPath = "/user/login";

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
  centerList?: any[];
}> {
  const fetchUserInfo = async () => {
    try {
      const res = await userControllerGetUserInfo();
      return res;
    } catch (_error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;

  if (
    ![loginPath, "/user/register", "/user/login"].includes(location.pathname)
  ) {
    const currentUser = await fetchUserInfo();
    const centerList = await commonControllerGetCenterList({
      page: 1,
      size: 100,
    });
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
      centerList: centerList.results,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      // <Question key="doc" />,
      // <SelectLang key="SelectLang" />,
    ],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, defaultDom) => {
        // @ts-ignore
        return <AvatarDropdown>{defaultDom}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      // content: initialState?.currentUser?.name,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (
        !window.localStorage.getItem("token") &&
        location.pathname !== loginPath
      ) {
        history.push(loginPath);
      }
    },
    bgLayoutImgList: [],
    links: isDev ? [] : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
//获取当前url域名 umijs 全局变量
const currentUrl = window.location.href;
const domain = currentUrl.split("/")[2];
console.log(domain);
export const request: RequestConfig = {
  baseURL:
    domain === "smartrial-edc.com"
      ? "https://smartrial-edc.com"
      : "https://dev.smartrial-edc.com",
  // baseURL: 'https://smartrial-edc.com',
  ...errorConfig,
};
